import type { FC } from 'react';

type HeadingProps = {
	as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
	mode?: 'primary' | 'secondary' | 'tertiary';
	className?: string;
	children: React.ReactNode;
};

export const Heading: FC<HeadingProps> = ({ as: Tag = 'h2', mode = 'secondary', className = '', children }) => {
	const baseStyles = 'font-bold skin-title-font';
	const modeStyles = {
		primary: 'text-4xl',
		secondary: 'text-2xl',
		tertiary: 'text-lg',
	}[mode];

	return <Tag className={`${baseStyles} ${modeStyles} ${className}`}>{children}</Tag>;
};
